/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_UploadedInputs */

const en_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploaded ✨`)
};

const es_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento subido ✨`)
};

const fr_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploadé ✨`)
};

const de_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument hochgeladen ✨`)
};

const ja_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメントがアップロードされました ✨`)
};

const zh_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档已上传 ✨`)
};

const ar_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم رفع المستند ✨`)
};

const id_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen diunggah ✨`)
};

const it_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento caricato ✨`)
};

const ru_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документ загружен ✨`)
};

const pt_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento enviado ✨`)
};

const ko_document_uploaded = /** @type {(inputs: Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 업로드 완료 ✨`)
};

/**
* | output |
* | --- |
* | "Document uploaded ✨" |
*
* @param {Document_UploadedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_uploaded = /** @type {((inputs?: Document_UploadedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_UploadedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_uploaded(inputs)
	if (locale === "es") return es_document_uploaded(inputs)
	if (locale === "fr") return fr_document_uploaded(inputs)
	if (locale === "de") return de_document_uploaded(inputs)
	if (locale === "ja") return ja_document_uploaded(inputs)
	if (locale === "zh") return zh_document_uploaded(inputs)
	if (locale === "ar") return ar_document_uploaded(inputs)
	if (locale === "id") return id_document_uploaded(inputs)
	if (locale === "it") return it_document_uploaded(inputs)
	if (locale === "ru") return ru_document_uploaded(inputs)
	if (locale === "pt") return pt_document_uploaded(inputs)
	return ko_document_uploaded(inputs)
});